// This file maps state to stores
import TemplateStore from '@src/stores/TemplateStore';
import ActionStore from '@src/ActionStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [TemplateStore, ActionStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  return {
    templateData: TemplateStore.getTemplateData(),
  };
}

export {
  showConfirmationDialog,
  updateComponentModal,
} from 'actions/BotActions';
export {
  fetchTemplateData,
  updateTemplateData,
  saveTemplateData,
} from 'actions/TemplateActions';
